import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoryComponent } from './physical/category/category.component';
import { SubCategoryComponent } from './physical/sub-category/sub-category.component';
import { ProductListComponent } from './physical/product-list/product-list.component';
import { AddProductComponent } from './physical/add-product/add-product.component';
import { DigitalCategoryComponent } from './digital/digital-category/digital-category.component';
import { DigitalSubCategoryComponent } from './digital/digital-sub-category/digital-sub-category.component';
import { DigitalListComponent } from './digital/digital-list/digital-list.component';
import { DigitalAddComponent } from './digital/digital-add/digital-add.component';
import { CollegeCourseComponent } from './digital/college-courses/college-courses-add.component';
import { CollegeFacilityComponent } from './digital/college-facility/college-facility-add.component';

import { CollegeVideosComponent } from './digital/college-videos/college-videos-add.component';

import { CollegePlacementsComponent } from './digital/college-placements/college-placements-add.component';

import { CollegeOtherComponent } from './digital/college-other/college-other-add.component';

import { CollegeDocumentsComponent } from './digital/college-documents/college-documents-add.component';

import { ProductDetailComponent } from './physical/product-detail/product-detail.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'physical/category',
        component: CategoryComponent,
        data: {
          title: "Category",
          breadcrumb: "Category"
        }
      },
      {
        path: 'physical/sub-category',
        component: SubCategoryComponent,
        data: {
          title: "Sub Category",
          breadcrumb: "Sub Category"
        }
      },
      {
        path: 'physical/product-list',
        component: ProductListComponent,
        data: {
          title: "Product List",
          breadcrumb: "Product List"
        }
      },
      {
        path: 'physical/product-detail',
        component: ProductDetailComponent,
        data: {
          title: "Product Detail",
          breadcrumb: "Product Detail"
        }
      },
      {
        path: 'physical/add-product',
        component: AddProductComponent,
        data: {
          title: "Add Products",
          breadcrumb: "Add Product"
        }
      },
      {
        path: 'digital/digital-category',
        component: DigitalCategoryComponent,
        data: {
          title: "Category",
          breadcrumb: "Category"
        }
      },
      {
        path: 'digital/digital-sub-category',
        component: DigitalSubCategoryComponent,
        data: {
          title: "Sub Category",
          breadcrumb: "Sub Category"
        }
      },
      {
        path: 'digital/digital-product-list',
        component: DigitalListComponent,
        data: {
          title: "Product List",
          breadcrumb: "Product List"
        }
      },
      {
        path: 'colleges/add-college-info',
        component: DigitalAddComponent,
        data: {
          title: "Add college Info",
          breadcrumb: "Add College Info"
        }
      },
	  {
        path: 'colleges/add-college-courses',
        component: CollegeCourseComponent,
        data: {
          title: "Add college Course",
          breadcrumb: "Add College Course"
        }
      },
	  {
        path: 'colleges/add-college-facility',
        component: CollegeFacilityComponent,
        data: {
          title: "Add college facility",
          breadcrumb: "Add College facility"
        }
      },
	  {
        path: 'colleges/add-college-other',
        component: CollegeOtherComponent,
        data: {
          title: "Add college Other Info",
          breadcrumb: "Add College Other Info"
        }
      },
	  {
        path: 'colleges/add-college-placements',
        component: CollegePlacementsComponent,
        data: {
          title: "Add college placements",
          breadcrumb: "Add College placements"
        }
      },
	  {
        path: 'colleges/add-college-videos',
        component: CollegeVideosComponent,
        data: {
          title: "Add college videos",
          breadcrumb: "Add College videos"
        }
      },
	  {
        path: 'colleges/add-college-documents',
        component: CollegeDocumentsComponent,
        data: {
          title: "Add college documents",
          breadcrumb: "Add College documents"
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
